module.exports = __webpack_public_path__ + "static/media/search.e0a7e520.svg";